import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { buildErrorMessage } from 'utils'
import { ApiError } from 'utils/error'

export interface Variables {
  campaignId: number
}

export const generateCampaignContent = async ({ campaignId }: Variables) => {
  const res = await sendToApi<void>(`/schedules/${campaignId}/generate_content`, {
    method: 'POST',
  })

  if (res.type === 'exception' && res.data instanceof DOMException && res.data.name === 'AbortError') {
    throw res
  }

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    if (res.data === 'cancel') {
      throw new DOMException('The operation was aborted.', 'AbortError')
    }
    const plainStringErrors = Array.isArray(res.data?.errors) && typeof res.data.errors[0] === 'string'

    const message =
      (plainStringErrors ? res.data.errors.join('. ') : buildErrorMessage(res.data.errors)) ||
      'An error occurred! Our team has been notified and we are looking into it.'

    throw plainStringErrors && res.data?.error_code
      ? new ApiError(message, res.data.error_code)
      : new Error(message)
  }

  return res.data
}

export interface Options extends Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'> {}

export const useGenerateCampaignContent = (options?: Options) => {
  return useMutation<void, Error, Variables>(generateCampaignContent, options)
}
